import React from "react";

export interface TitleCaseProps {
  text: string;
}

export function toTitleCase(input: string): string {
  return input.trim()
    .replace(/[_-]/g, ' ') // Replace underscores and hyphens with spaces
    .replace(/\s+/g, " ")  // If replacing characters results in multiple spaces in a row, merge them down into a single space
    .split(' ')
    .map((word) => word[0]?.toLocaleUpperCase() + word.slice(1)).join(' ');
}

export default function TitleCase(props: TitleCaseProps): JSX.Element {
  let titleCaseString = props.text;
  if (typeof(titleCaseString) === "string") {
    titleCaseString = toTitleCase(titleCaseString);
  }

  return <>{titleCaseString}</>;
}
